export const en = {
  action: {
    goIt: "Join",
  },
  msg: {
    emptyApp: "No applications available. Contact the administration, thanks.",
  },
  error: {
    loadApp: "Error loading application list. Please try again later, thanks!",
  },
  layout: {
    footer: "© Linde 2018-",
  },
};
